import { render, staticRenderFns } from "./ComponentCopyTrade.vue?vue&type=template&id=37328c7a&scoped=true"
import script from "./ComponentCopyTrade.vue?vue&type=script&lang=js"
export * from "./ComponentCopyTrade.vue?vue&type=script&lang=js"
import style0 from "./ComponentCopyTrade.vue?vue&type=style&index=0&id=37328c7a&prod&lang=css"
import style1 from "./ComponentCopyTrade.vue?vue&type=style&index=1&id=37328c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37328c7a",
  null
  
)

export default component.exports